async function sendToApi(path, payload) {
  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload),
    mode: 'same-origin'
  });

  const text = await response.text().catch(() => '');

  if (!response.ok) {
    const error = new Error(`Webhook error: ${response.status}`);
    error.details = text;
    throw error;
  }

  return text;
}

export async function submitFormToWebhook(formType, data) {
  const payload = {
    ...data,
    timestamp: new Date().toISOString(),
    formType
  };

  return await sendToApi('/api/free-audit', payload);
}

export async function submitAuditToWebhook(data) {
  const payload = {
    ...data,
    timestamp: new Date().toISOString(),
    formType: 'Free GEO/AIO Audit Request'
  };

  return await sendToApi('/api/free-audit', payload);
}

export async function submitContactToWebhook(data) {
  const payload = {
    ...data,
    timestamp: new Date().toISOString(),
    formType: 'Contact Form'
  };

  return await sendToApi('/api/contact', payload);
}
